<template>
    <div>
        <input
            ref="phoneInput"
            type="tel"
            :name="name"
            :id="id"
            :placeholder="placeholder"
            :required="required"
            :class="[{ 'input-error': error }, 'intl-tel-input']"
            :value="internalValue"
            @blur="$emit('blur')"
        />
        <div v-if="error" :id="ariaDescribedby">
            <small class="ck-error-message">{{ errorMessage }}</small>
        </div>
    </div>
</template>

<script>
import { initPhoneInput } from "../commons/common_phone-input";

export default {
    name: "IntlTelInputCustom",
    props: {
        value: {
            type: String,
            default: ""
        },
        id: {
            type: String,
            default: "phone"
        },
        name: {
          type: String,
          default: "mobilePhone"
        },
        placeholder: {
            type: String,
            default: "Votre téléphone *"
        },
        required: {
            type: Boolean,
            default: true
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ""
        },
        ariaDescribedby: {
            type: String,
            default: "phone-errors"
        },
        options: {
            type: Object,
            default: () => ({
                initialCountry: "fr",
                preferredCountries: ["fr", "be", "ch"],
                nationalMode: false,
                strictMode: false,
                countrySearch: false,
                loadUtils: () => import("intl-tel-input/build/js/utils"),
            }),
        },
    },
    data() {
        return {
            phoneHelper: null,
            internalValue: this.value,
        };
    },
    mounted() {
        this.initPlugin();
    },
    beforeDestroy() {
        if (this.phoneHelper) this.phoneHelper.destroy();
    },
    methods: {
        initPlugin() {
            this.phoneHelper = initPhoneInput(this.$refs.phoneInput, {
                ...this.options,
                initialValue : this.internalValue,
                onChangeNumber: (num) => {
                    this.internalValue = num;
                    this.$emit("input", num);
                },
                onChangeCountry: (country) => {
                  this.$emit("change-country", country)
                  this.$emit("changeCountry", country)
                },
                onChangeValidity: (valid) => {
                  this.$emit("change-validity", valid)
                  this.$emit("changeValidity", valid)
                },
                onChangeErrorCode: (code) => {
                  this.$emit("change-error-code", code)
                  this.$emit("changeErrorCode", code)
                },
            });
        },

    }
};
</script>

<style>
@import "intl-tel-input/build/css/intlTelInput.css";
    .iti {
        display: block !important;
    }
</style>
